import React from 'react';
import {NeuroMessage, RenderOnlyFor, usePages} from "@ignitesales/neuro-application";
import classnames from "classnames";
import PropTypes from 'prop-types';

const ReturnToSurveyButton = ({ className, useIcon = true }) => {
    const { goToPreviousPage } = usePages();
    const componentClass = "returnToSurveyButton";
    const classes = classnames(componentClass, className);

    return <RenderOnlyFor forSummaryPage={true}>
        <div className={classes}>
            <button className="btn back-btn" onClick={goToPreviousPage}>
                {useIcon && <i className="ion-md-arrow-back"/>}
                <NeuroMessage id='summary.previousPageBtn'/>
            </button>
        </div>
    </RenderOnlyFor>
};

ReturnToSurveyButton.propTypes = {
  useIcon: PropTypes.bool
};

export default ReturnToSurveyButton;
